/* ----------------------------------------------------------------------
 * Funções auxiliares de validação.
 * ----------------------------------------------------------------------
 */

function filter_curso() {

    // esconde todas as tr

    var linhas = $('#tab_cursos tbody tr:not(.tab-legenda)');
    linhas.addClass('hide');

    // modalidade
    var modalidades = $('#filtro_modalidade input:checked');
    var tipos = $('#filtro_tipo input:checked');
    var turnos = $('#filtro_turno input:checked');

    classes = [];
    $.each(modalidades, function (key, modalidade) {
        classes.push('.' + modalidade.value);
    });
    var classNamesModalidades = classes.join(', ');
    linhas.filter(classNamesModalidades).removeClass('hide');

    classes = [];
    $.each(turnos, function (key, turno) {
        classes.push('.' + turno.value);
    });
    var classNamesTurnos = classes.join(', ');
    linhas.filter(classNamesModalidades).filter(':not(' + classNamesTurnos + ')').addClass('hide');
}

/**
 * Desabilita seleção de curso conforme regra de negócio
 */
function disable(opcao, curso_id, curso_tipo) {

    var inputs = $('input[name='+opcao+']');
    // libera todas
    $('input[name='+opcao+']').removeAttr('disabled');
    // bloqueia específico
    $.each(inputs, function(key, input) {

        if(input.value == curso_id) {
            input.setAttribute('disabled', 'disabled');
            input.checked = false;

            // se a primeira opção for Tecnologia desabilita 2º de engenharia
            if(curso_tipo === 'Tecnologia') {
                $('tr[class*=Engenharia]').find('input[name=opcao2]').removeAttr('checked');
                $('tr[class*=Engenharia]').find('input[name=opcao2]').attr('disabled', 'disabled');
                $('tr[class*=Arquitetura]').find('input[name=opcao2]').removeAttr('checked');
                $('tr[class*=Arquitetura]').find('input[name=opcao2]').attr('disabled', 'disabled');
            }
        }
    });
}


/**
 * Botao voltar
 */
function button_back() {
    $('div.form-buttons button[type=button]').click(function () {
        controll_tab--;
        controll_button_back();
        $('#tab-etapas li:eq('+(controll_tab)+') a').tab('show');
    });
}

function controll_button_back() {

    if(controll_tab == 0) {
        $('div.form-buttons button[type=button]').addClass('disabled');
    }

    if(controll_tab > 0) {
        $('div.form-buttons button[type=button]').removeClass('disabled');
    }

}

/**
 * Retorna os cursos ofertados de acordo com processo seletivo informado e a filial
 */
function ajaxCursos() {

    var input_vestibular = $('input[name=vestibular_id]:checked');

    var vestibular_id = input_vestibular.val();
    var filial_id = $('input[name=filial_id]:checked').val();

    // Se o vestibular escolhido for do tipo EAD busca os cursos da filial 1 (Caxias).
    if (input_vestibular.attr('isead')) {
        filial_id = 1;
    }

    var _token = $('input[name=_token]').val();
    if(!vestibular_id) return;

    ajaxStartLoading();
    $.ajax({
        type: 'POST',
        url: '/inscricao/ajax/processo-cursos',
        data: {vestibular_id: vestibular_id, filial_id: filial_id, _token: _token},
        success: function( data ) {
            var html = '';

            html += '<table id="tab_cursos" class="table">';
            html +=    '<thead>';
            html +=        '<tr>';
            html +=            '<th class=\"text-center\">1º <br />Opção</th>';
            html +=            '<th class=\"text-center\">2º <br />Opção</th>';
            html +=            '<th>Turno</th>';
            html +=            '<th>Curso</th>';
            html +=            '<th>Modalidade</th>';
            html +=            '<th>Vagas</th>';
            /*html +=            '<th>Categoria</th>';*/
            html +=        '</tr>';
            html +=    '</thead>';
            html+='<tbody>';

            var cursoTipoAtual = '';

            $.each(data.cursos, function(key, curso) {

                if (cursoTipoAtual != curso.curso_tipo) {
                    cursoTipoAtual = curso.curso_tipo;
                    html += '<tr class="tab-legenda ' + cursoTipoAtual + '"><th colspan="6">' + cursoTipoAtual + '</th></tr>';
                }

                var classLinhaCurso = 'linha_' + curso.curso_id;

                html += '<tr class="'+curso.curso_tipo+' '+curso.modalidade+' '+curso.turno + ' ' + classLinhaCurso + '">';
                html +=     '<td class=\"hidden\">';
                html +=    '   <input type="hidden" name="hidden_curso_id" class="curso_id" value="'+curso.curso_id+'" />';
                html +=    '   <input type="hidden" name="hidden_turno_id" class="turno_id" value="'+curso.turno_id+'" />';
                html +=    '   <input type="hidden" name="hidden_matriz" class="matriz_aplicada" value="'+curso.matriz_aplicada+'" />';
                html +=    '   <input type="hidden" name="hidden_curso" class="curso_nome" value="'+curso.curso+' - '+curso.turno+'" />';
                html +=     '</td>';
                html +=    '<td class=\"text-center\"><input type="radio" name="opcao1" value="'+curso.curso_id+'" required="required" /></td>';
                html +=    '<td class=\"text-center\"><input type="radio" name="opcao2" value="'+curso.curso_id+'" required="required" /></td>';
                html +=    '<td>'+curso.turno+'</td>';
                html +=    '<td>'+ ( curso.descricao_inscricao || curso.curso );
                html +=    '</td>';
                html +=    '<td>'+curso.modalidade+'</td>';
                html +=    '<td><span class="badge">'+curso.vagas+'</span></td>';
                html += '</tr>';

            });

            html +=    '</tbody>';
            html += '</table>';

            $('#grid-cursos').html(html);

            AJAX_CURSOS_CARREGADOS = true;

            // Após carregar os cursos atrela os eventos de seleção
            // Salva em campos hidden as opções de escolha de curso

            var table = $("#tab_cursos");

            // Seta as configuracoes da opcao1
            table.find('tbody tr input[name=opcao1]').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-blue',
                increaseArea: '20%'
            }).on('ifChecked', function(){

                var linha = $(this).parents('tr');

                var curso_id = linha.find('input.curso_id').val();
                var turno_id = linha.find('input.turno_id').val();
                var matriz_aplicada = linha.find('input.matriz_aplicada').val();
                var curso_nome = linha.find('input.curso_nome').val();

                //.curso_id
                //.turno_id
                //.matriz_aplicada
                //.curso_nome

                $('#name_opcao1').html(curso_nome);
                $('#selected_opcao1').val(curso_id + '#' + turno_id + '#' + matriz_aplicada + '#' + curso_nome);

                // SE tiver mais de 2 cursos disponiveis, aplica as validacoes de opcao1 e opcao2,
                //  nao permitindo que o mesmo curso (em turnos diferentes) seja marcado como opcao 2.
                var checkTotalCursos = $("input[name=opcao1]").length;

                //TODO:

                if (linha.hasClass("Arquitetura e Engenharias")) {

                    checkTotalCursos = table.find("tr.Arquitetura.Engenharias input[name=opcao1]").length;
                } else if (linha.hasClass("Outros Bacharelados")) {

                    checkTotalCursos = table.find("tr.Outros.Bacharelados input[name=opcao1]").length;
                } else if (linha.hasClass("Tecnologia")) {

                    checkTotalCursos = table.find("tr.Tecnologia input[name=opcao1]").length;
                }

                if (checkTotalCursos > 2) {
                    // Bloqueia cursos......................................
                    table.find('input[name=opcao1], input[name=opcao2]').iCheck('enable');

                    // DESATIVA o mesmo curso selecionado na opcao1 para a opcao2
                    table.find('input[name=opcao2][value=' + curso_id + ']')
                        .iCheck('uncheck')
                        .iCheck('disable')
                        .parents('tr').removeClass('marcar-linha');
                } else {
                    // Marca automaticamente o mesmo curso como segunda opcao.
                    $(this).parent().parent().parent().find('input[name=opcao2]').iCheck('check');
                }

                //if (!checkVestibularSelecionadoPrivado()) {
                    // Se for do tipo "Outros Bacharelados" OU "Tecnologia" desativa todas as "Arquiteturas e Engenharias"
                    if (linha.hasClass('Outros Bacharelados') || linha.hasClass('Tecnologia')) {
                        table.find('.Engenharias input[name=opcao2]')
                            .iCheck('uncheck')
                            .iCheck('disable')
                            .parents('tr').removeClass('marcar-linha');
                    }
                //}

                table.find('tbody tr').removeClass('marcar-linha');
                table.find('tbody tr input[name=opcao2]:checked').parents('tr').addClass('marcar-linha');
                linha.addClass('marcar-linha');
            });

            // Seta as configuracoes da opcao2
            table.find('tbody tr input[name=opcao2]').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-blue',
                increaseArea: '20%'
            }).on('ifChecked', function(){

                var linha = $(this).parents('tr');
                table.find('tbody tr').removeClass('marcar-linha');
                table.find('tbody tr input[name=opcao1]:checked').parents('tr').addClass('marcar-linha');
                linha.addClass('marcar-linha');

                var curso_id = linha.find('input.curso_id').val();
                var turno_id = linha.find('input.turno_id').val();
                var matriz_aplicada = linha.find('input.matriz_aplicada').val();
                var curso_nome = linha.find('input.curso_nome').val();

                $('#name_opcao2').html(curso_nome);
                $('#selected_opcao2').val(curso_id + '#' + turno_id + '#' + matriz_aplicada + '#' + curso_nome);
            });

            /// Quando for transferencia de inscrito (admin)
            var header = $('#transferencia_header');
            var inscricao = header.find("#inscricao_id");
            if (inscricao.length == 1) {
                //console.log('set local_prova_id');
                var local_prova_id = header.find('#local_prova_id').val()
                var opcao1_id = header.find('#opcao1').val();
                var opcao2_id = header.find('#opcao2').val();

                if(!$('#enem_inscricao').val()) {
                    $('#tab_locais_prova input[name=local_prova_id][value=' + local_prova_id + ']').iCheck('check');
                }
                $('#tab_cursos input[name=opcao1][value=' + opcao1_id + ']').iCheck('check').change();
                $('#tab_cursos input[name=opcao2][value=' + opcao2_id + ']').iCheck('check').change();
            }

            // TODO: QUIZ
            if (VESTIBULAR_QUIZ) {
                $('button.btn.btn-default.pull-right').click();
            }

            ajaxStopLoading();
        },
        complete: function() {

            var url_string = window.location.href;
            var url = new URL(url_string);
            var curso_id = url.searchParams.get("curso");

            if(curso_id) {
                array_cursos = curso_id.split(',');

                array_cursos.forEach(function (str) {
                    $(":radio[name='opcao1'][value="+str+"]").iCheck('check');
                });
            }

        }
    });
}

/* Retorna a tab ativa */
function activeTab() {
    return $('div#menu-etapas ul li.active a').attr('aria-controls');
}

/**
 * Recebe um array com campos obrigatórios e valida se todos foram preenchidos
 * @param obr
 * @returns {boolean}
 */
function verifyObr(obr) {
    // Verifica se todos os campos obrigatórios da etapa foram preenchidos
    var ok = true;

    // Procura por id ou name (radio e checkbox)
    $.each(obr, function (key, field) {

        if(!$('#' + field).val()) {
            if(!$('input[name='+field+']:checked').val()) {
                ok = false;

                var objPai = $("#" + field).parent();
                if(objPai && objPai.is('.required') && !objPai.is('.has-error')) {
                    objPai.addClass('has-error').append('<div class="help-block">Campo obrigatório.</div>');
                }
                // <div class="help-block">Somente números.</div>
            }
        }
    });

    return ok;
}

/**
 * Libera tab para navegação
 * @param tab
 */
function libera_tab(tab) {
    var tab_i = controll_tab + 1;
    $("a[href=#tab"+tab_i+"]").parent().removeClass('disabled');
    $("a[href=#tab"+tab_i+"]").attr('data-toggle','tab');
}

/**
 * Reseta os requires que foram adicionados pela etapa condicional
 * @param etapa
 */
function reset_obr_groups(etapa) {

    if(etapa == 2) {
        // Remove Required dos locais de prova
        $("input[name=local_prova_id]").removeAttr('required');

        // Add required aos campos do ENEM
        $('#enem_ano').attr('required', true);
        $('#enem_inscricao').attr('required', true);
        $('#enem_nota_objetiva').attr('required', true);
        $('#enem_nota_redacao').attr('required', true);
    } else if (etapa == 1) {

        // Add required aos locais de prova
        $("input[name=local_prova_id]").attr('required', true);

        // Remove required dos campos do ENEM
        $('#enem_ano').removeAttr('required');
        $('#enem_inscricao').removeAttr('required');
        $('#enem_nota_objetiva').removeAttr('required');
        $('#enem_nota_redacao').removeAttr('required');
    }
}

/**
 * Verifica se o candidato já inscreveu-se em outro processo anteriormente, realizando a busc apor cpf
 * @param cpf
 */
function buscaPorCpf(cpf) {
    ajaxStartLoading();

    $.ajax({
        type: 'POST',
        url: "/inscricao/cpf",
        dataType: 'json',
        data: { cpf: cpf, _token: $('input[name=_token]').val() },
        success: function( data )
        {
            ajaxStopLoading();
            if(typeof(data) == 'object'){
                var arrData = data.pessoa_fisica.data_nascimento.split('-');

                $('#group_data_nascimento').datepicker('setDate', new Date(arrData[0], parseInt(arrData[1])-1, arrData[2].split(' ')[0]));
                $('#rg').val(data.pessoa_fisica.rg);

                //$('#fone1').val(data.pessoa_fisica.fone_celular);
                $('#fone2').val(data.pessoa_fisica.fone_residencial);
                $('#fone3').val(data.pessoa_fisica.fone_comercial);

                $('#sexo option[value='+data.pessoa_fisica.sexo+']').prop('selected', 'selected').change();
                $('#etnia_id option[value='+data.pessoa_fisica.etnia_id+']').prop('selected', 'selected').change();

                // necessidades especiais
                var necessidades = data.necessidades_especiais;

                $.each(necessidades, function(key, necessidade) {
                    //$('#group_necessidades input[value='+necessidade+']').prop('checked', 'checked');
                    $('#group_necessidades input[value='+necessidade+']').iCheck('check');
                });

                // pessoa
                $('#cep').val(data.pessoa.cep);
                $('#cidade').val(data.pessoa.cidade);
                $('#bairro').val(data.pessoa.bairro);
                $('#logradouro').val(data.pessoa.logradouro);
                $('#numero').val(data.pessoa.numero);

                $('#uf_id option[value='+data.pessoa.uf_id+']').prop('selected', 'selected').change();
            }
        }
    });
}

/**
 * Validacao CPF
 * @param i
 */
function vCPF(obj) {
    if (validaCPF(obj.value)) {
        buscaPorCpf(obj.value);
    } else {
        obj.value = '';
    }
}

function validarCpfSemBusca(obj) {
    if (validaCPF(obj.value)) {
        return true;
    }
    obj.value = '';
    return false;
}

function validaCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g,'');
    if(cpf == '') return false;
    // Elimina CPFs invalidos conhecidos
    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999")
        return false;
    // Valida 1o digito
    add = 0;
    for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
        return false;
    // Valida 2o digito
    add = 0;
    for (i = 0; i < 10; i ++)
        add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
        return false;
    return true;
}

function ajaxStartLoading() {
    $('.loading').removeClass('hidden');
}

function ajaxStopLoading() {
    $('.loading').addClass('hidden');
}


/**
 * Buscar Locais da prova quando selecionado o Vestibular na etapa 2 (Forma de Ingresso)
 */
function buscarLocaisProva(obj) {

    //var vestibular_id = $('input[name=vestibular_id]:checked').val();
    var vestibular_id = obj.filter(':checked').val();
    if(vestibular_id) {
        $.ajax({
            type: 'POST',
            url: $('#url_buscar_locais_provas').text(),
            data: {
                vestibular_id: vestibular_id,
                _token: $('input[name=_token]').val()
            },
            success: function (data) {

                if (data) {
                    var html = '';
                    $.each(data, function (i, obj) {
                        var input = '<input name="local_prova_id" type="radio" value="' + obj.id + '" required="required">';
                        html += '<tr class=\"local_prova_id_' + obj.id + '\"><td>' + input + '</td>';
                        html += '<td><a class=\"link-check\" local_prova_id=\"' + obj.id + '\">' + obj.descricao + '</a></td>';
                        html += '<td>' + obj.logradouro + ', ' + obj.numero + ' - ' + obj.bairro + ' -' + obj.cidade + ' /  CEP: ' + obj.cep + '</td></tr>';
                    });

                    var table = $("#tab_locais_prova");
                    table.find('tbody').html(html);
                    table.show();

                    var table = $('#tab_locais_prova');

                    // Monta o icheck na tabela de Locais da Prova
                    table.find('input[name=local_prova_id]').iCheck({
                        checkboxClass: 'icheckbox_square-green',
                        radioClass: 'iradio_square-blue',
                        increaseArea: '20%'
                    }).on('ifChanged', function(){
                        table.find('tbody tr').removeClass('marcar-linha');
                        table.find('tbody tr.local_prova_id_' + this.value).addClass('marcar-linha');
                    });
                    table.find('tbody tr .link-check').on('click', function(){
                        table.find('tbody tr.local_prova_id_' + $(this).attr('local_prova_id') + ' input[name=local_prova_id]').iCheck('check');
                    });

                    // Seta obrigatoriedade, de acordo com a opcao escolhida em forma de ingresso:
                    reset_obr_groups($('input[name=forma_ingresso]:checked').val());

                    if (data.length == 1) {
                        // Se trouxer apenas um local de prova, seleciona-lo automaticamente.
                        table.find('input[name=local_prova_id]').iCheck('check');
                    }
                }
            }
        });
    }
}

/**
 * Busca as possiveis datas de provas do vestibular continuado e monta o calendario
 * tipo_busca:
 *  - 'T': Todas as datas disponiveis
 *  - 'P': Apenas as proximas datas a partir de hoje.
 * @param obj
 */
function buscarVestibularcontinuadoDatas(obj, tipo_busca) {

    if (!tipo_busca) {
        tipo_busca == 'P';
    }

    var vestibular = obj.filter(':checked');

    var vestibular_id = vestibular.val();
    var tipoVestibular = vestibular.attr('tipo_vestibular');

    var groupVestibularContinuado = $("#group_vestibular_continuado");

    if(vestibular_id && tipoVestibular == 'C') {
        // Executa somente quando o vestibular eh do tipo CONTINUADO

        $.ajax({
            type: 'POST',
            url: $('#url_buscar_vestibular_continuado_datas').text(),
            data: {
                vestibular_id: vestibular_id,
                tipo_busca: tipo_busca,
                _token: $('input[name=_token]').val()
            },
            success: function (lista) {

                if (lista && lista.length > 0) {

                    var html = '<option value=""></option>';
                    $.each(lista, function(i, data) {

                        var dataMoment = moment(data.dataFormatada, 'DD/MM/YYYY');

                        if (data.turno_manha.horaInicial) {
                            html += '<option value="' + data.turno_manha.id + '">' + dataMoment.format('DD/MM/YYYY - dddd') + ' às ' + data.turno_manha.horaInicial + 'h - Manhã ' +'</option>';
                        }
                        if (data.turno_tarde.horaInicial) {
                            html += '<option value="' + data.turno_tarde.id + '">' + dataMoment.format('DD/MM/YYYY - dddd') + ' às ' + data.turno_tarde.horaInicial + 'h - Tarde ' +'</option>';
                        }
                        if (data.turno_noite.horaInicial) {
                            html += '<option value="' + data.turno_noite.id + '">' + dataMoment.format('DD/MM/YYYY - dddd') + ' às ' + data.turno_noite.horaInicial + 'h - Noite ' +'</option>';
                        }
                    });

                    var input = groupVestibularContinuado.find('#vestibular_continuado_datas')
                    input.html(html);
                    var idSelecionado = input.attr('id_selecionado');
                    if (idSelecionado) {
                        input.val(idSelecionado).change();
                    }

                    // Verifica a forma de ingresso marcada, se for ENEM nao mostra o bloco Datas para Realização da Prova
                    var forma_ingresso = $('input[name=forma_ingresso]:checked').val();
                    if (forma_ingresso != 2) {
                        groupVestibularContinuado.removeClass('hide');
                    }
                }
            }
        });
    } else {
        groupVestibularContinuado.addClass('hide');
    }
}

function montarInputNotaEnem() {
    $('.nota-enem').mask('9999,99').prop({'placeholder': "Valor entre 0,00 e 1000,00" });
}

function validaNotaEnem(obj) {
    var valor = obj.value;
    if (valor) {
        valor = parseFloat(valor.replace(/,/g,'.'));
        if ((valor > 1000.0) || (valor < 0.0)) {
            $(obj).val('').parent().addClass('has-error');
        }
    }
}

function checkVestibularSelecionadoPrivado() {

    var vestibular_id = $('input[name=vestibular_id]:checked').val();
    var checkPrivado = false;

    $.each(lista_processos, function(i, processo) {
        if (processo.id == vestibular_id) {
            if ( processo.tipo_vestibular == 'P') {
                checkPrivado = true
            }
            return false;
        }
    });
    return checkPrivado;
}

function checkVestibularContinuado() {

    var vestibular_id = $('input[name=vestibular_id]:checked').val();
    var checkPrivado = false;

    $.each(lista_processos, function(i, processo) {
        if (processo.id == vestibular_id) {
            if ( processo.tipo_vestibular == 'C') {
                checkPrivado = true
            }
            return false;
        }
    });
    return checkPrivado;
}

function montarCamposEscola() {

    $("#escola").select2({
        ajax: {
            url: "/inscricao/ajax/escolas",
            dataType: 'json',
            delay: 250,
            cache: true,
            async: true,
            data: function (params) {
                return {
                    q: params.term, // search term
                    cidade_escola: $("#cidade_escola").val(),
                    page: params.page
                };
            },
            processResults: function (data, params) {
                //params.page = params.page || 1;
                return {
                    results: data,
                    pagination: {
                        more: (params.page * 30) < data.total_count
                    }
                };
            }
        },
        closeOnSelect: true,
        allowClear: false,
        enable: true,
        readonly: false,
        multiple: false,
        minimumInputLength: 2,
        placeholder: 'Pesquisar por Escola',
        language: "pt-BR",
        templateResult: function (repo) {
            if (repo.loading) return repo.text;
            return repo.title;
        }, // omitted for brevity, see the source of this page
        templateSelection: function (repo) {
            if (repo.id > 0) return (repo.title || repo.text);
            else return 'Pesquisar por Escola';
        } // omitted for brevity, see the source of this page
    }).prop('disabled', true);

    $("#cidade_escola").select2({
        placeholder: 'Selecione a Cidade',
        allowClear: true
    }).change(function() {
        if (this.value > 0) {
            $("#escola").prop('disabled', false);
        } else {
            $("#escola").prop('disabled', true);
        }
    }).change();
}

function montarCampoVestibularContinuadoDatas() {
    $("#vestibular_continuado_datas").width('100%').select2({
        language: 'pt-BR',
        placeholder: 'Selecione',
        allowClear: true
    });
}


function validarEmail(valor) {
    var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
    if (testEmail.test(valor)) {
        return true;
    }
    return false;
}

function validarCampoEmail(obj) {
    if (validarEmail(obj.value)) {
        return true;
    }
    obj.value = '';
    return false;
}

function validarEtapa2() {

    var retorno = true;

    var divFormasIngresso = $(".formas-ingresso");
    var forma_ingresso = $('input[name=forma_ingresso]:checked').val();

    var vestibular_id = $("input[name=vestibular_id]:checked").val();
    var divTabVestibular = $("#divTabVestibular");

    if (forma_ingresso) {
        if (divFormasIngresso.hasClass('has-error')) {
            divFormasIngresso.removeClass('has-error');
            divFormasIngresso.find(".help-block").remove();
        }
    }

    if (!vestibular_id) {
        if (!divTabVestibular.hasClass('has-error')) {
            divTabVestibular.addClass('has-error')
            divTabVestibular.append('<div class="help-block alert alert-danger" role="alert">Selecione um <Strong>Processo Seletivo</Strong>.</div>');
        }
        retorno = false;
    } else {
        if (divTabVestibular.hasClass('has-error')) {
            divTabVestibular.removeClass('has-error');
            divTabVestibular.find(".help-block").remove();
        }
    }

    // 1 = vestibular padrão / 2 = ENEM / 3 = Outros (transferência e diploma)
    switch(forma_ingresso) {
        case '1' :
            var localProvaId = $("[name='local_prova_id']:checked").val();
            var divTabLocalProva = $("#divTabLocalProva");
            if ( vestibular_id && !localProvaId) {
                if (!divTabLocalProva.hasClass('has-error')){
                    divTabLocalProva.addClass('has-error');
                    divTabLocalProva.append('<div class="help-block alert alert-danger" role="alert">Selecione um <Strong>Local de Prova</Strong>.</div>');
                }
                retorno = false;
            } else {
                if (divTabLocalProva.hasClass('has-error')){
                    divTabLocalProva.removeClass('has-error');
                    divTabLocalProva.find(".help-block").remove();
                }
            }

            if (checkVestibularContinuado()) {
                var continuadoDatas = $("#vestibular_continuado_datas");
                var divContinuadoDatas = $("#div_vestibular_continuado_datas");

                if (!continuadoDatas.val()) {
                    if (!divContinuadoDatas.hasClass('has-error')){
                        divContinuadoDatas.addClass('has-error');
                        divContinuadoDatas.append('<div class="help-block alert alert-danger" role="alert">Selecione uma <Strong>Data e Hora da Prova</Strong>.</div>');
                    }
                    retorno = false;
                } else {
                    if (divContinuadoDatas.hasClass('has-error')){
                        divContinuadoDatas.removeClass('has-error');
                        divContinuadoDatas.find(".help-block").remove();
                    }
                }
            }
            break;

        case '2' :
            $('#enem_ano').prop('required', 'required');
            $('#enem_inscricao').prop('required', 'required');
            $('#enem_nota_objetiva').prop('required', 'required');
            $('#enem_nota_redacao').prop('required', 'required');

            obr = ['enem_ano', 'enem_inscricao', 'enem_nota_objetiva', 'enem_nota_redacao'];

            if (!verifyObr(obr)) {
                retorno = false;
            }
            break;

        case '3' :
            break;

        default:
            if (!divFormasIngresso.hasClass('has-error')) {
                divFormasIngresso.addClass('has-error');
                divFormasIngresso.append('<div class="help-block">Selecione uma Forma de Ingresso.</div>')
            }
            retorno = false;
            break;
    }

    return retorno;
}

function validarEtapa3() {
    var retorno = true;

    var opcao1_id = $("input[name=opcao1]:checked").val();
    var opcao2_id = $("input[name=opcao2]:checked").val();

    var gridCursos = $("#grid-cursos");
    if (!opcao1_id || !opcao2_id) {
        var msgErro = '';
        if (!opcao1_id) {
            msgErro += 'Selecione a <strong>Primeira Opção de Curso</strong>.<br>';
        }
        if (!opcao2_id) {
            msgErro += 'Selecione a <strong>Segunda Opção de Curso</strong>.<br>';
        }

        if (!gridCursos.hasClass('has-error')) {
            gridCursos.addClass('has-error');
            gridCursos.append('<div class="help-block alert alert-danger" role="alert">' + msgErro + '</div>');
        }
        retorno = false;
    } else {
        if (gridCursos.hasClass('has-error')) {
            gridCursos.removeClass('has-error');
            gridCursos.find('.help-block').remove();
        }
    }

    return retorno;
}

function formatarEtapa4() {

    var campoPais = $("#pais");

    campoPais.select2({
        allowClear: false,
        placeholder: 'Selecione seu País',
        language: "pt-BR"
    }).on('change', function() {
        selectPais(this);
    });
    campoPais.change();

    $("#sexo").select2({
        allowClear: true,
        placeholder: 'Selecione seu Sexo',
        language: "pt-BR"
    });

    $("#uf_id").select2({
        allowClear: false,
        placeholder: 'Selecione seu Estado',
        language: "pt-BR"
    });

    $(".select2.select2-container").width('100%');
}

/**
 * Acao ao Selecionar o Pais. Se Pais = 1 (Brasil) exibe o Documento de CPF,
 *   Se pais diferente de 1 (outros) oculta o CPF e exibe o Documento estrangeiro.
 * @param obj
 */
function selectPais(obj) {

    var blockDocExtrangeiro = $("#blockDocExtrangeiro");
    var blockDocNacional = $("#blockDocNacional");

    var fone1 = $("#fone1");
    var fone2 = $("#fone2");

    if (obj.value == 1) {
        // CPF obrigatorio
        blockDocExtrangeiro.addClass('hide').removeClass('required');
        blockDocNacional.removeClass('hide').addClass('required');

        fone1.addClass('fone');
        fone2.addClass('fone');

        fone1.mask('(00) 0000-00009');
        fone2.mask('(00) 0000-00009');

    } else {
        // Documento estrangeiro obrigatorio
        blockDocNacional.addClass('hide').removeClass('required');
        blockDocExtrangeiro.removeClass('hide').addClass('required');

        fone1.removeClass('fone');
        fone2.removeClass('fone');

        fone1.mask('+99 (99) 9999-99999');
        fone2.mask('+99 (99) 9999-99999');
    }
}

/**
 * Aplica as formatacoes do bloco e campos para escolha do Consultor Comercial
 */
function formatarBlocoConsultor() {

    var divBlocoConsultor = $(".bloco-consultor");
    divBlocoConsultor.hide();
    var selectConsultor = divBlocoConsultor.find('#consultor_usuarioid');
    selectConsultor.width('100%').select2({
        allowClear: true,
        placeholder: 'Selecione o consultor',
        language: "pt-BR"
    });

    var radioRecebeuAtendimentoSim = $("#atendimento_consultor_sim");
    var radioRecebeuAtendimentoNao = $("#atendimento_consultor_nao");

    radioRecebeuAtendimentoSim.iCheck({
        checkboxClass: 'iradiobox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    }).on('ifChanged', function(){
        if (this.checked) {
            divBlocoConsultor.show();
        }
    });

    radioRecebeuAtendimentoNao.iCheck({
        checkboxClass: 'iradiobox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    }).on('ifChanged', function(){
        if (this.checked) {
            divBlocoConsultor.hide();
            selectConsultor.val('').change();
        }
    });

    if (selectConsultor.val()) {
        radioRecebeuAtendimentoSim.iCheck('check');
    }
}

function validarBlocoConsultor() {
    var valido = true;
    var radioRecebeuAtendimentoSim = $("#atendimento_consultor_sim");
    var radioRecebeuAtendimentoNao = $("#atendimento_consultor_nao");
    var legend = $("#group_consultor .required");

    if (!radioRecebeuAtendimentoSim.is(':checked') && !radioRecebeuAtendimentoNao.is(':checked')) {
        valido = false;
        if (!legend.hasClass('has-error')) {
            legend.addClass('has-error').append('<div class="help-block">Informe se você Recebeu atendimento de algum consultor.</div>');
        }
    }
    return valido;
}

function validarUtilizarNotaEnem(obj) {

    console.log('permitir_nota_enem:: ', obj.attr('permitir_nota_enem'));

    var permitir = obj.attr('permitir_nota_enem');
    if (permitir == 0) {
        // Marca a forma de ingresso FAZER A PROVA DO VESTIBULAR
        $(".formas-ingresso input[name=forma_ingresso][value=1]").iCheck('check');
        // Desativa a forma de ingresso do ENEM
        $(".formas-ingresso input[name=forma_ingresso][value=2]").iCheck('disable');
        // Oculta
    } else {
        // exibe os itens da nota do enem
        $(".formas-ingresso input[name=forma_ingresso][value=2]").iCheck('enable');
    }
}

function getCandidatoParams(param) {
    return decodeURI($.trim($.urlParam(param)));
}

$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results && results.length > 1) {
        return decodeURIComponent(results[1] || 0);
    }
    return null;
};